export default __webpack_public_path__ + "static/media/uparrow.089aa9f1.svg";